module.exports = __webpack_public_path__ + "img/nameFrame.5b3bd786.png";